export default "END-USER AGREEMENT TBA\n"